// Shared by the header's skip link and every page's <main>, which cannot
// both import from core/ (pages → core is disallowed by TSS vite/01).
export const MAIN_CONTENT_ID = 'contenido';
